export function getSiteUrl(suffix?: string): string {
  const url = process.env.SITE_URL || window.location.origin;

  return `${url}${suffix}`;
}
